import FotoPerfil from './renderFotoPerfil';
import React from 'react';

export default (props) => {
  
        return (
                <div 
                    className="media-raking comentarios-post-item" 
                    id={`comentario_post_${props.id}`} 
                    >
                    <div className="media-left">
                        <FotoPerfil width="40" height="40" className="media-object img-rounded" src={props.foto} />
                    </div>
                    <div className="media-body">
                        <span className="media-heading user-nome-post"><b>{props.nome}</b></span>
                         {props.use_id === props.use_id_com ? props.funcao : "" } 
                        <p>{props.coment}</p>
                    </div>
                </div>
               );
}


// WEBPACK FOOTER //
// ./src/container/renderComentarioPostTimelineEquipe.js